import api from '@/services/utils/apiInstance.ts';
import { displayNonNotFoundError } from '@/utils/apiErrorUtils.ts';

import type { CustomAxiosRequestConfig } from '@/types/services/utils/axios.type.ts';
import type { KycDocument, KycDocumentsResponseApi } from '@/types/services/user/kycDocument.type.ts';

class KycDocumentService {
  // Returns `[]` if there's no KYC at all for this user, or if the existing KYC predates the
  // Dataleon v3 migration (no `kyc_id`) — 404, format A (`kyc_not_found_error_key`).
  // Each call regenerates the document list (and fresh presigned `downloadUrl`s) straight from
  // Dataleon — nothing is cached on our backend or here, so a page reload always yields fresh URLs.
  async getKycDocuments(userId: number): Promise<KycDocument[]> {
    try {
      const response = await api.get(
        `/kyc/bo/${userId}/documents`,
        { disableGlobalError: true } as CustomAxiosRequestConfig
      )
      const data: KycDocumentsResponseApi = response.data

      return (data.documents ?? []).map(doc => ({
        id: doc.id,
        name: doc.name,
        filename: doc.filename,
        documentType: doc.document_type,
        state: doc.state,
        status: doc.status,
        downloadUrl: doc.download_url
      }))
    } catch (error) {
      displayNonNotFoundError(error)
      return []
    }
  }
}

export default new KycDocumentService();
